import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DOCS_SECTIONS } from '@/components/Docs';
import { LedgerRow } from '@/components/Ui/LedgerRow';
import { Page } from '@/components/Ui/Page';
import { PageHeader } from '@/components/Ui/PageHeader';
import { Section } from '@/components/Ui/Section';
import { UiLink } from '@/components/Ui/UiLink';
import { useLanguageAwareRouting } from '@/hooks/useLanguageAwareRouting';
import shared from './AccountScreens.module.css';

export function AccountDocsPage() {
  const { t } = useTranslation();
  const { createLanguageURL } = useLanguageAwareRouting();
  // The docs are a public page outside the account shell, so they open in their own tab.
  const docsHref = `#${createLanguageURL('/docs')}`;

  return (
    <Page width="narrow">
      <PageHeader
        title={t('docs.account.title')}
        subtitle={t('docs.account.subtitle')}
        actions={
          <Button component="a" href={docsHref} target="_blank" rel="noopener noreferrer">
            {t('docs.account.open')}
          </Button>
        }
      />

      <Section title={t('docs.account.topics')}>
        {DOCS_SECTIONS.map((section) => (
          <LedgerRow
            key={section.id}
            label={
              <a
                href={`${docsHref}?section=${section.id}`}
                target="_blank"
                rel="noopener noreferrer"
                className={shared.link}
              >
                {t(section.titleKey)}
              </a>
            }
            value={<span className={shared.sub}>{t(section.subtitleKey)}</span>}
          />
        ))}
      </Section>

      <Section title={t('docs.account.moreTitle')}>
        <LedgerRow
          label={<UiLink to="/account/developers">{t('nav.developers')}</UiLink>}
          value={<span className={shared.sub}>{t('docs.account.developers')}</span>}
        />
        <LedgerRow
          label={<UiLink to="/account/support">{t('nav.support')}</UiLink>}
          value={<span className={shared.sub}>{t('docs.account.support')}</span>}
        />
      </Section>
    </Page>
  );
}
